import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { ACCESS_TYPE, CONTENT_GROUP_TYPES, CONTENT_GROUP_STATUS_TYPES, CONTENT_GROUP_SUBTYPES } from '../types/others';
import { ContentGroup } from '../types/contentGroup';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';

export const MinimalContentGroupSchema = yup.object().shape({
  title: yupUtils.stringRequired('Title is a required field'),
  category: yupUtils.stringOptionalNullable,
  pillarType: yupUtils.stringOptionalNullable,
  pillarExpertise: yupUtils.stringOptionalNullable,
  type: yupUtils.stringRequiredOneOf(CONTENT_GROUP_TYPES),
});

export const ContentGroupSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  createdAt: yupUtils.numberRequired,
  updatedAt: yupUtils.numberRequired,
  status: yupUtils.stringNullableOneOf(CONTENT_GROUP_STATUS_TYPES),
  publishedAt: yupUtils.numberOptionalNullable,
  category: yupUtils.stringOptionalNullable,
  imagePath: yupUtils.stringOptionalNullable,
  type: yupUtils.stringRequiredOneOf(CONTENT_GROUP_TYPES),
  subType: yupUtils.stringNullableOneOf(CONTENT_GROUP_SUBTYPES),
  description: yupUtils.stringOptionalNullable,
  otherCategories: yupUtils.arrayOptionalNullableOf(yupUtils.stringRequired()),
  itemIds: yupUtils.arrayOptionalNullableOf(yupUtils.stringRequired()),
  freeItemIds: yupUtils.arrayOptionalNullableOf(yupUtils.stringRequired()),
  accessType: yupUtils.arrayOptionalNullableOf(yupUtils.stringRequiredOneOf(ACCESS_TYPE)),
  specialAccessType: yupUtils.stringOptionalNullable,
  authorId: yupUtils.stringOptionalNullable,
  priceTier: yupUtils.stringOptionalNullable,
  purchaseId: yupUtils.stringOptionalNullable,
  pillarType: yupUtils.stringOptionalNullable,
  pillarExpertise: yupUtils.stringOptionalNullable,
  temporary: yupUtils.booleanOptionalNullable,
  removeFromSale: yupUtils.booleanOptionalNullable,
  isTestingGroup: yupUtils.booleanOptionalNullable,
  packId: yupUtils.stringOptionalNullable,
  tags: yupUtils.arrayOptionalNullableOf(yup.string()),
  bulletPoints: yupUtils.arrayOptionalNullableOf(yup.string()),
  pathGoal: yupUtils.stringOptionalNullable,
});

const processContentGroup = async (contentGroup: any): Promise<ContentGroup> => {
  return {
    ...contentGroup,
    publishedAtDate: contentGroup?.publishedAt ? new Date(contentGroup?.publishedAt) : undefined,
  };
};

export const parseContentGroup = async (object: any): Promise<ContentGroup | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(ContentGroupSchema, object)) {
      return processContentGroup(object as ContentGroup);
    }
    return getProjectErrorForCode(ProjectErrors.invalidContentGroup);
  } catch (error) {
    console.log(`[CONTENT GROUPS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseContentGroups = async (items: any): Promise<ContentGroup[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[CONTENT GROUPS] Error: No array found.');
    return [];
  }

  const data: ContentGroup[] = [];
  for (const item of items) {
    const o = await parseContentGroup(item);
    if (o && !isProjectError(o)) {
      data.push(o as ContentGroup);
    }
  }

  return data;
};
